import { cn } from "@/lib/utils";

export function Metric({ label, value, sub, accent = "orange", testid }) {
  const color = { orange: "text-xd-orange", blue: "text-xd-blue", green: "text-xd-green", white: "text-white" }[accent];
  return (
    <div data-testid={testid} className="bg-xd-paper border border-xd-border rounded-lg p-5 hover:border-xd-orange/50 transition-colors">
      <p className="text-xs uppercase tracking-[0.15em] font-bold text-xd-dim">{label}</p>
      <p className={cn("mt-2 font-heading text-3xl font-black tracking-tight", color)}>{value}</p>
      {sub && <p className="mt-1 text-xs text-xd-muted">{sub}</p>}
    </div>
  );
}

export function DemoBadge({ className }) {
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full bg-xd-yellow/15 text-xd-yellow border border-xd-yellow/30 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide", className)}>
      <span className="w-1.5 h-1.5 rounded-full bg-xd-yellow" /> Demo Data
    </span>
  );
}

export function ComingSoon({ className }) {
  return (
    <span className={cn("inline-flex items-center rounded-full bg-xd-blue/15 text-xd-blue border border-xd-blue/30 px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wide", className)}>
      Coming Soon
    </span>
  );
}

export function ScoreBar({ label, value, recommendation }) {
  const color = value >= 85 ? "#34C759" : value >= 60 ? "#007AFF" : "#FF5500";
  return (
    <div data-testid={`score-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between text-sm mb-1.5">
        <span className="font-medium text-white">{label}</span>
        <span className="font-mono font-bold" style={{ color }}>{value}</span>
      </div>
      <div className="h-2 rounded-full bg-xd-border overflow-hidden">
        <div className="h-full rounded-full transition-all" style={{ width: `${value}%`, background: color }} />
      </div>
      {recommendation && <p className="mt-1.5 text-xs text-xd-muted">↳ {recommendation}</p>}
    </div>
  );
}

export function StatusPill({ status }) {
  const map = {
    Available: "bg-xd-green/15 text-xd-green border-xd-green/30",
    Paid: "bg-xd-green/15 text-xd-green border-xd-green/30",
    Delivered: "bg-xd-green/15 text-xd-green border-xd-green/30",
    Cancelled: "bg-xd-red/15 text-xd-red border-xd-red/30",
    approved: "bg-xd-green/15 text-xd-green border-xd-green/30",
    rejected: "bg-xd-red/15 text-xd-red border-xd-red/30",
    submitted: "bg-xd-yellow/15 text-xd-yellow border-xd-yellow/30",
    docs_requested: "bg-xd-orange/15 text-xd-orange border-xd-orange/30",
    new: "bg-xd-blue/15 text-xd-blue border-xd-blue/30",
  };
  const cls = map[status] || "bg-xd-blue/15 text-xd-blue border-xd-blue/30";
  return <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap", cls)}>{status}</span>;
}
